/** The signed-in migrator's last 50 imports: legacy number → ITSM number, date. */

import { Typography } from "@norican/react";
import { Link } from "react-router";

import {
  EmptyStateBlock,
  ErrorState,
  LoadingRows,
  SectionCard,
  useDateFormatter,
} from "@/components/common";
import { useT } from "@/i18n";

import { useMigrationHistory } from "../api";

export function HistoryList() {
  const { t } = useT("tickets");
  const { formatDateTime } = useDateFormatter();
  const history = useMigrationHistory();
  const items = history.data?.items ?? [];

  return (
    <SectionCard title={t("migrate.history.title")}>
      {history.isLoading ? (
        <LoadingRows rows={3} />
      ) : history.error != null ? (
        <ErrorState variant="inline" error={history.error} onRetry={() => void history.refetch()} />
      ) : items.length === 0 ? (
        <EmptyStateBlock title={t("migrate.history.empty")} description={null} size="sm" />
      ) : (
        <ul className="divide-border flex flex-col divide-y">
          {items.map((item) => (
            <li
              key={item.legacy_number}
              className="flex flex-wrap items-center justify-between gap-2 py-2"
            >
              <Link to={item.url_path} className="text-accent-fg-subtle hover:underline">
                {t("migrate.history.row", {
                  legacy: item.legacy_number,
                  number: item.ticket_number,
                })}
              </Link>
              <Typography variant="caption" tone="muted">
                {item.customer_name} · {formatDateTime(item.migrated_at)}
              </Typography>
            </li>
          ))}
        </ul>
      )}
    </SectionCard>
  );
}
